import { useMemo } from 'react';
import useFeatures from './useFeatures';

export const useCheckTenantLicense = (featureKey: string) => {
  const { data, loading } = useFeatures();

  const isFeatureEnabled = useMemo(() => {
    if (!Array.isArray(data)) return false;
    return data.some((feature) => feature.key === featureKey);
  }, [data, featureKey]);

  return { isFeatureEnabled: isFeatureEnabled, isLoading: loading };
};

const MOBILE_FORCE_UPDATE_FEATURE_KEY = 'veengu_unbound_mobile_apps_force_update';
export const useCheckAppUpdateLicence = () => {
  return useCheckTenantLicense(MOBILE_FORCE_UPDATE_FEATURE_KEY);
};

const APPROVAL_CASES_FEATURE_KEY = 'veengu_tenant_approval_cases';
export const useCheckApprovalCasesLicence = () => {
  return useCheckTenantLicense(APPROVAL_CASES_FEATURE_KEY);
};
